import axios from '@/libs/api.request'

export const getClientNums = async (that, data) => {
    var res = await axios.request({
        url: '/shop/statics/getClientNums',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getClientStatics = async (that, data) => {
    var res = await axios.request({
        url: '/shop/statics/getClientStatics',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getDataReport = async (that, data) => {
    var res = await axios.request({
        url: '/shop/statics/getDataReport',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getClientFollowAnalyse = async (that, data) => {
    var res = await axios.request({
        url: '/shop/statics/getClientFollowAnalyse',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getWorkReportData = async (that, data) => {
    var res = await axios.request({
        url: '/shop/statics/getWorkReportData',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getDepartmentStaticData = async (that, data) => {
    var res = await axios.request({
        url: '/shop/statics/getDepartmentStaticData',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getFollowNums = async (that, data) => {
	that.$Spin.show();
    var res = await axios.request({
        url: '/shop/statics/getFollowNums',
        data,
        method: 'post'
    })
    res = res.data;
	that.$Spin.hide();
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getDoorNums = async (that, data) => {
	that.$Spin.show();
    var res = await axios.request({
        url: '/shop/statics/getDoorNums',
        data,
        method: 'post'
    })
    res = res.data;
	that.$Spin.hide();
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getSeaNums = async (that, data) => {
	that.$Spin.show();
    var res = await axios.request({
        url: '/shop/statics/getSeaNums',
        data,
        method: 'post'
    })
    res = res.data;
	that.$Spin.hide();
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getConversion = async (that, data) => {
	that.$Spin.show();
    var res = await axios.request({
        url: '/shop/statics/getConversion',
        data,
        method: 'post'
    })
    res = res.data;
	that.$Spin.hide();
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getComprehensive = async (that, data) => {
	that.$Spin.show();
    var res = await axios.request({
        url: '/shop/statics/getComprehensive',
        data,
        method: 'post'
    })
    res = res.data;
	that.$Spin.hide();
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getRankList = async (that, data) => {
	that.$Spin.show();
    var res = await axios.request({
        url: '/shop/statics/getRankList',
        data,
        method: 'post'
    })
    res = res.data;
	that.$Spin.hide();
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getRankData = async (that, data) => {
	that.$Spin.show();
    var res = await axios.request({
        url: '/shop/statics/getRankData',
        data,
        method: 'post'
    })
    res = res.data;
	that.$Spin.hide();
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getMonthConversion = async (that, data) => {
	that.$Spin.show();
    var res = await axios.request({
        url: '/shop/statics/getMonthConversion',
        data,
        method: 'post'
    })
    res = res.data;
	that.$Spin.hide();
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getUpChannelMonthConversion = async (that, data) => {
    var res = await axios.request({
        url: '/shop/statics/getUpChannelMonthConversion',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getCompanyMonthConversion = async (that, data) => {
    var res = await axios.request({
        url: '/shop/statics/getCompanyMonthConversion',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getTeamMonthConversion = async (that, data) => {
    var res = await axios.request({
        url: '/shop/statics/getTeamMonthConversion',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getCallLogList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/statics/getCallLogList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}